function debounce(fn, delay) {
    let timeoutID = null as any;
    return function (...arg: any[]) {
        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
            fn.apply(this, arg);
        }, delay)
    }
}

// IE Support
function createNewEvent(eventName) {
    let e;
    if (typeof(Event) === 'function') {
        e = new Event(eventName);
    } else {
        e = document.createEvent('Event');
        e.initEvent(eventName, true, true);
    }
    return e;
}

// Attach directive to element and wait for input to stop. Default timeout 800ms or 0.8s.
const directive = (el, bind) => {
    if (bind.value !== bind.oldValue) { // change debounce only if interval has changed
        el.oninput = debounce(function (e) {
            el.dispatchEvent(createNewEvent('change'));
        }, parseInt(bind.value) || 500)
    }
}

export default directive